import { TableCell, TableRow, Typography } from "@mui/material";
import type { FC } from "react";
import type { ActiveCustomerRow } from "../statisticsApi";
import { formatContactCalculations, formatEur, formatPercent } from "../statisticsFormat";
import ReportTable, { CustomerLink } from "./ReportTable";

const COLUMNS = [
  { label: "Klient" },
  { label: "Zamówienia", align: "right" as const },
  { label: "Zaliczki", align: "right" as const },
  { label: "Anulowane", align: "right" as const },
  { label: "Kalkulacje", align: "right" as const },
];

interface Props {
  readonly rows: ActiveCustomerRow[];
}

const ActiveCustomersTable: FC<Props> = ({ rows }) => {
  if (rows.length === 0) {
    return <Typography sx={{ color: "text.secondary" }}>Brak aktywnych klientów w wybranym okresie</Typography>;
  }
  return (
    <ReportTable columns={COLUMNS}>
      {rows.map((row) => (
        <TableRow key={row.customerId} hover>
          <TableCell>
            <CustomerLink customerId={row.customerId} customerName={row.customerName} />
          </TableCell>
          <TableCell align="right">
            {row.orders.count} · {formatEur(row.orders.valueEur)}
          </TableCell>
          <TableCell align="right">
            {row.advancePaid.count} ({formatPercent(row.advancePaid.percent)}) · {formatEur(row.advancePaid.valueEur)}
          </TableCell>
          <TableCell align="right">
            {row.cancelled.count} ({formatPercent(row.cancelled.percent)})
          </TableCell>
          <TableCell align="right">{formatContactCalculations(row.calculations)}</TableCell>
        </TableRow>
      ))}
    </ReportTable>
  );
};

export default ActiveCustomersTable;
